import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import SeatMobileIcon from '../../../icons/SeatMobileIcon';
import './FlightSeatsStyles.css';

const FlightSeats = ({ flightId, seats }) =>
  flightId && seats ? (
    <div className='flight-seats clearfix'>
      <div className='pull-left items-center'>
        <label className='flight'>{Dictionary.flights.flight}</label> &nbsp;&nbsp;
        {flightId}
      </div>
      <div className='pull-right items-center'>
        <SeatMobileIcon className='seat-mobile-icon' color='#607D8B' />&nbsp;&nbsp;
        {/* <label>{Dictionary.flights.seats}</label> &nbsp;&nbsp; */}
        {seats}
      </div>
    </div>
  ) : null;

FlightSeats.propTypes = {
  flightId: PropTypes.string,
  seats: PropTypes.string,
};

export default FlightSeats;



// WEBPACK FOOTER //
// ./src/components/flights/flightSeats/FlightSeats.js